import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FormulaEditor = () => {
  const [headings, setHeadings] = useState([]);
  const [selectedHeading, setSelectedHeading] = useState('');
  const [formulas, setFormulas] = useState([]);

  // Fetch Headings
  useEffect(() => {
    axios.get('https://ideatorportal.in/api/get_headings.php')
      .then((res) => setHeadings(res.data))
      .catch((err) => console.error('Error fetching headings:', err));
  }, []);

  // Fetch Formulas for selected heading
  useEffect(() => {
    if (!selectedHeading) return;

    axios.get('https://ideatorportal.in/api/get_formulas.php')
      .then((res) => {
        const filtered = res.data.filter(f => f.heading_id === selectedHeading);
        setFormulas(filtered);
      })
      .catch((err) => console.error("Error fetching formulas:", err));
  }, [selectedHeading]);

  // Handle input change
  const handleChange = (id, field, value) => {
    setFormulas(prev =>
      prev.map(f => (f.id === id ? { ...f, [field]: value } : f))
    );
  };

  // Save formula changes
  const handleSave = async (formula) => {
    try {
      const res = await axios.post('https://ideatorportal.in/api/update_formula.php', {
        id: formula.id,
        material_quantity: parseFloat(formula.material_quantity),
        base_quantity: parseFloat(formula.base_quantity)
      });

      if (res.data.success) {
        alert('✅ Formula updated!');
      } else {
        alert('❌ Update failed.');
      }
    } catch (err) {
      alert('❌ API error occurred.');
    }
  };

  // Delete formula
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this formula?")) return;

    try {
      const res = await axios.post('https://ideatorportal.in/api/delete_formula.php', {
        id
      });

      if (res.data.success) {
        setFormulas(prev => prev.filter(f => f.id !== id));
        alert('🗑️ Formula deleted.');
      } else {
        alert('❌ Delete failed.');
      }
    } catch (err) {
      alert('❌ API error occurred.');
    }
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow border max-w-5xl mx-auto mt-6">
      <h2 className="text-2xl font-bold mb-4">🧮 Formula Editor</h2>

      {/* Dropdown */}
      <div className="mb-6">
        <label className="block text-lg font-semibold mb-2">Select Work Heading:</label>
        <select
          value={selectedHeading}
          onChange={(e) => setSelectedHeading(e.target.value)}
          className="w-full border rounded px-3 py-2"
        >
          <option value="">-- Select Heading --</option>
          {headings.map((h) => (
            <option key={h.id} value={h.id}>
              {h.name} ({h.unit})
            </option>
          ))}
        </select>
      </div>

      {/* Formulas */}
      {selectedHeading ? (
        <div className="space-y-6">
          {formulas.map((f) => (
            <div key={f.id} className="bg-gray-100 p-4 rounded-xl shadow border">
              <h3 className="text-lg font-semibold mb-2 text-blue-700">{f.material_name}</h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">Material Quantity ({f.material_unit})</label>
                  <input
                    type="number"
                    value={f.material_quantity}
                    className="border px-3 py-2 rounded w-full"
                    onChange={(e) =>
                      handleChange(f.id, 'material_quantity', e.target.value)
                    }
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Base Quantity ({f.heading_unit})</label>
                  <input
                    type="number"
                    value={f.base_quantity}
                    className="border px-3 py-2 rounded w-full"
                    onChange={(e) =>
                      handleChange(f.id, 'base_quantity', e.target.value)
                    }
                  />
                </div>
              </div>

              <div className="mt-4 text-sm text-gray-600">
                <strong>Unit Ratio:</strong> {f.material_unit} / {f.heading_unit}
              </div>

              <div className="flex items-center gap-4 mt-4">
                <button
                  onClick={() => handleSave(f)}
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  💾 Save Formula
                </button>

                <button
                  onClick={() => handleDelete(f.id)}
                  className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
                >
                  🗑️ Delete Formula
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-gray-500 text-center mt-4">
          Please select a heading to view and edit formulas.
        </div>
      )}
    </div>
  );
};

export default FormulaEditor;
